/* eslint-disable import/no-anonymous-default-export */
const OTT = "OTT";
const STUDIO = "STUDIO";

export default {
  STUDIO,
  OTT,
};
